import React, { useMemo } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import GetAppIcon from '@mui/icons-material/GetApp';
import LaunchIcon from '@mui/icons-material/Launch';
import { generateFulltextLinkMenu } from '../../GlobalSearch/helper';
import { useResultCardController } from '../../GlobalSearch/SearchModal/components/ResultListGroups/components/ResultCard/ResultCard.controller';
import { getActionTooltip } from '../../GlobalSearch/SearchModal/components/ResultListGroups/components/ResultCard/ResultCard';

const useStyles = makeStyles((theme) => ({
  groupTitle: {
    fontSize: theme.fontSizes.base,
    fontWeight: 800,
    textDecoration: 'underline',
  },
  label: {
    fontWeight: 'bold',
  },
  linkItem: {
    display: 'flex',
    flexDirection: 'row',
    padding: '20px 0',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.palette.baseColors.deepSeaNavy.c100,
  },
  linksWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px',
  },
  listIcon: {
    marginRight: '4px',
  },
}));

export const LinkItem = ({ type, rows, onActionClick }) => {
  const classes = useStyles();
  const row = useMemo(() => rows[0], [rows]);
  const link = generateFulltextLinkMenu(row);
  const { download } = useResultCardController(row);
  const { action, label } = type;

  return (
    <Box className={classes.linksWrapper}>
      {download ? (
        <Tooltip title={getActionTooltip(action)}>
          <div className={classes.linkItem}>
            <GetAppIcon className={classes.listIcon} />
            <Typography
              onClick={(e) => {
                onActionClick({
                  download: true,
                  row,
                });
                download(e);
              }}
              color="textPrimary"
              className={classes.label}
            >
              {label}
            </Typography>
          </div>
        </Tooltip>
      ) : link ? (
        <Tooltip title={getActionTooltip(action)}>
          <a
            className={classes.linkItem}
            href={link.link}
            onClick={() =>
              onActionClick({
                download: false,
                row,
              })
            }
            target="_blank"
            rel="noreferrer"
          >
            <LaunchIcon className={classes.listIcon} />
            <Typography color="textPrimary" className={classes.label}>
              {label}
            </Typography>
          </a>
        </Tooltip>
      ) : null}
    </Box>
  );
};
